import { render, staticRenderFns } from "./singleselect.vue?vue&type=template&id=77403c5c&scoped=true"
import script from "./singleselect.vue?vue&type=script&lang=js"
export * from "./singleselect.vue?vue&type=script&lang=js"
import style0 from "./singleselect.vue?vue&type=style&index=0&id=77403c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77403c5c",
  null
  
)

export default component.exports